import { ExecutionTimeoutFrequency } from "@pages/workflow-page/SchedulePipelinesForm";
import { ScheduleTiming } from "@pages/workflow-page/modals/schedule-workflow";
import { Moment } from 'moment';

const servers = ["pi-edge-and-dom"];
const databases = ["AnalysisDB"];
const sinkOptions = [{ label: 'S3', value: 'S3', type: 's3' },{ label: 'ADLS Gen 2', value: 'ADLSGen2', type: 'ADLSGen2' }];
const sinkOptionsIp21 = [{ label: 'S3', value: 'S3', type: 's3' },{ label: 'Azure Blob', value: 'AzureBlob', type: 'AzureBlob' }];
const modeOptions = [
    { label: "Append", value: "Append" },
    { label: "Overwrite", value: "Overwrite" },
    { label: "Ignore", value: "Ignore" },
]

const tagFilterTypeOptions = [
    { label: "Number", value: "number" },
    { label: "String", value: "string" },
    { label: "Null values", value: "null" },
]

const conditionTypeOptions = [
    { label: "Equal to", value: "equal_to" },
    { label: "Not Equal to", value: "not_equal_to" },
    { label: "Greater than", value: "greater_than" },
    { label: "Less than", value: "less_than" },
    { label: "Greater than or Equal to", value: "greater_than_or_equal_to" },
    { label: "Less than or Equal to", value: "less_than_or_equal_to" },
]

const interploted_valuesOptions = [
    { label: "Sample Values Every", value: "sample_values" },
    { label: "Use Key Column", value: "key_column" },
]

const requestTypeOptions = [
    { label: "Raw", value: "raw" },
    { label: "Real Time", value: "real_time" },
    { label: "Interpolated", value: "interpolated" },
    { label: "Summary", value: "summary" },
]

const summaryTypeOptions = [
    { label: "Total", value: "total" },
    { label: "Average", value: "average" },
    { label: "Minimum", value: "minimum" },
    { label: "Maximum", value: "maximum" },
    { label: "Range", value: "range" },
    { label: "StdDev", value: "stddev" },
    { label: "Population StdDev", value: "populationstddev" },
    { label: "Count", value: "count" },
    { label: "Percent Good", value: "percentgood" },
    { label: "Total With UOM", value: "totalwithuom" },
    { label: "All", value: "all" },
    { label: "All For Non Numeric", value: "allfornonnumeric" },
]

const calculationBasisOptions = [
    { label: "Time Weighted", value: "timeweighted" },
    { label: "Event Weighted", value: "eventweighted" },
    { label: "Time Weighted Continuous", value: "timeweightedcontinuous" },
    { label: "Time Weighted Discrete", value: "timeweighteddiscrete" },
    { label: "Event Weighted Exclude Most Recent Event", value: "eventweightedexcludemostrecentevent" },
    { label: "Event Weighted Exclude Earliest Event", value: "eventweightedexcludeearliestevent" },
    { label: "Event Weighted Include Both Ends", value: "eventweightedincludebothends" },
]

const summaryTimeTypeOptions = [
    { label: "Auto", value: "auto" },
    { label: "Earliest Time", value: "earliesttime" },
    { label: "Most Recent Time", value: "mostrecenttime" },
]

const summaryIntervalUnitOptions = [
    { label: "Seconds", value: "s" },
    { label: "Minutes", value: "m" },
    { label: "Hours", value: "h" },
    { label: "Days", value: "d" },
]

const outputFormatOptions = [
    { label: "Json", value: "json" },
    { label: "Csv", value: "csv" },
]
const realTimeOptions = [
    { label: "Current", value: "current" },
    { label: "Live", value: "live" },
]

type Attribute = {
    attr_categories?: string;
    attr_id: string;
    attr_name?: string;
    attr_template?: string;
    attr_trait?: string;
    attr_type?: string;
    creation_date: string;
    effective_date: string;
    modify_date: string;
    obsolete_date: string;
    pipoint_id?: string;
    pipoint_name?: string;
    pipoint_type?: string;
    pipoint_class?: string;
    uom?: string;
    template?: string;
    path: string;
    name: string;
    tag: string;
    pipointName?: string;
    pipointType?: string;
    pipointClass?: string;
};

export type RootType = {
    element_id: string;
    element_name: string;
    parent: string;
    children: RootType[];
    parent_id?: string;
    path: string;
    creation_date: string;
    effective_date: string;
    modify_date: string;
    attributes: Attribute[]
    name: string;
    elementPath: string;
    columns: RootType[];
    elementId: string;
    database: string;
    originalName: string;
    safeName: string;
    schema: string;
};

export type RootSearchType = {
    element_id: string;
    element_name: string;
    parent: string;
    elementId: string;
    children: RootType[];
    parent_id?: string;
    creation_date: string;
    effective_date: string;
    modify_date: string;
    attr_categories?: string | undefined;
    attr_id: string;
    attr_name?: string | undefined;
    attr_template?: string | undefined;
    attr_trait?: string | undefined;
    attr_type?: string | undefined;
    path: string;
    pipoint_name?: string ;
    name: string;
    elementPath: string;
    pipointName?: string;
    pipointType?: string;
    pipointClass?: string;
    columns: RootType[];
    database: string;
    originalName: string;
    safeName: string;
    schema: string;
};

type scheduleInfoForDagGenDto = {
    dag_id: string;
    cronExpression: string;
    scheduleType: string;
    mins: number;
    days: number | string;
    weekOfTheMonth: number;
    hrs: number;
    retries: number;
    retryDelay: number;
    execution_timeout: number | null;
    execution_timeout_frequency: ExecutionTimeoutFrequency;
    overrideNotificationEmail: boolean;
    notificationEmails: string;
    notificationType: string;
    scheduleAdvancedMode: boolean;
    startDate: string;
    weekDays: string;
    months: number;
    scheduleTimingInfo: ScheduleTiming,
    runOnceExecutionDate: Moment,
    formattedRunOnceExecutionDate: string;
    cluster?: string;
    max_active_runs: string,
    catchup: boolean,
    exponential_backoff: boolean
    schedule_interval: string;
} | null;

type sinkDetails = {
  sinkKind: string;
  sinkName: string;
  databaseType: string;
  landingConnectionName: string;
  tableName: string;
  landingEnabled: boolean;
  fsType: string;
  connectionNameForExternalStaging: string;
  externalStagingLocation: string;
  createNewTable: boolean;
  schema: string;
  warehouse: string;
  userRole: string;
  mode: string;
}| null;

export type ModelRequestType = {
    dagGenDto: scheduleInfoForDagGenDto;
    dataBaseName: string;
    id: number;
    licenseId: string;
    query: string;
    mode:"runOnce" | "recurring";
    modelRequestName: string;
    nodeName: string;
    requestJson: string;
    serverName: string;
    sinkKind: string;
    sinkName: string;
    tagSelections: string[];
    requestType: string;
    realTimeValues: string;
    frequency: string;
    frequencyType: string;
    period_ms: string
    tagSelectedType: string;
    created: string;
    all_descendants:boolean;
    output_format: string;
    databaseType: string;
    tableName: string;
    landingEnabled: boolean;
    refresh_period_ms: string;
    sinkDetails: sinkDetails;
    piIntegratorWorkflowIdOne: string;
    piIntegratorWorkflowIdTwo: string;
    rdbmsIntegratorWorkflowIdOne: string;
    rdbmsIntegratorWorkflowIdTwo: string;
    ip21IntegratorWorkflowIdOne: string;
    ip21IntegratorWorkflowIdTwo: string;
    changeColumns: string[];
    parameterType:string[];
    parameterValues:{increment:string,initial:string}[];
    parameters:ParameterField[],
    requestControl:{initialParams :ParameterField[]},
    isAttributesManualEntry?: boolean;
}

export type ColumnField = {
    id: string;
    value: string;
};

export type ParameterField = {
    id: string;
    type: string;
    value: string;
    name: string,
    initialValue: string,
    incrementalValue: number | null
};

const formTitle: Record<number, string> = {
    0: "Attribute Selection",
    1: "Data Configuration",
    2: "Sink Options",
    3: "Schedule Options"
}

const storageTypeOptions = [
  { label: 'DBFS', value: 'dbfs' },
  { label: 'AWS S3', value: 's3' },
  { label: 'Azure Blob Storage', value: 'azure_blob' },
  { label: 'Azure Data Lake Gen 2', value: 'gen2' }
];

const modeOptionsIp21 = [
    { label: "Run Once", value: "runOnce" },
    { label: "Recurring", value: "recurring" },
]
const parameterOptionsIp21Type = [
    { label: "Single", value: "single" },
    { label: "Pair", value: "pair" },
]

export { servers, databases, sinkOptions, modeOptions, tagFilterTypeOptions, conditionTypeOptions, interploted_valuesOptions, formTitle, requestTypeOptions, realTimeOptions,outputFormatOptions, storageTypeOptions, sinkOptionsIp21, modeOptionsIp21, parameterOptionsIp21Type, summaryTypeOptions, calculationBasisOptions, summaryTimeTypeOptions, summaryIntervalUnitOptions };